import React from 'react';
import { useNavigate } from 'react-router-dom';
import { PageContainer, PageHeader } from '../../components/AssetBreadCrumb';
import { PageBackButton } from '../../components/PageChrome';
import ApiDocumentation from '../../components/ApiDocs/ApiDocumentation';

const ApiDocsPage: React.FC = () => {
  const navigate = useNavigate();

  return (
    // The docs browser scrolls itself under a pinned header, so the page takes the viewport
    <PageContainer fullHeight>
      <PageHeader
        eyebrow="Resources"
        title="REST API Documentation"
        description="Explore and test the Erode API endpoints with interactive documentation."
        className="shrink-0"
        action={
          <PageBackButton label="Back to Resources" onClick={() => navigate('/home/resources')} />
        }
      />

      <div className="min-h-0 flex-1 overflow-auto">
        <ApiDocumentation />
      </div>
    </PageContainer>
  );
};

export default ApiDocsPage;
